/** English labels the migrations seed for levels that have a translated name. */
export const SEEDED_LEVEL_LABELS: Readonly<Record<string, string>> = {
  'contractor-self-log': 'Contractor (logs own time)',
}

/** A level's display name: its translation while the label is still the seeded one, else the label an admin set. */
export function levelName(
  t: (key: string, options: { defaultValue: string }) => string,
  level: { slug: string; label?: string | null },
): string {
  const label = level.label || level.slug
  const seeded = SEEDED_LEVEL_LABELS[level.slug]
  if (seeded === undefined || label !== seeded) return label
  return t(`admin.levelName.${level.slug}`, { defaultValue: label })
}
